<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-02-20 13:00:54
 * @LastEditTime : 2025-02-20 13:27:37
 * @LastEditors  : yangxr
 * @Description  : 车辆排队信息
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\carLineInfo.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">站点名称</span>
                  <el-select ref="selection" v-model="tableParam.stationId" style="width: 300px" filterable @change="queryTable()">
                    <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="queryTable()">查 询</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card" style="padding-top: 3px;">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table ref="table3" :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%"
                :data="tableData3New" tooltip-effect="dark" :span-method="arraySpanMethod">
                <template v-for="(item, index2) in table3">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :fixed="item.fixed"
                    :width="item.width">
                    <template slot-scope="scope">
                      <div v-if="scope.$index == 2 && item.prop !== 'lineName'" class="car">
                        <div v-for="(carItem, carIndex) in scope.row[item.prop]" :key="carIndex"
                          style="margin-left: 10px">
                          <el-dropdown :hide-on-click="true" :disabled="carItem.indexOf('↑') != -1" trigger="click">
                            <div>{{ carItem }}</div>
                            <el-dropdown-menu slot="dropdown" style="text-align: left">
                              <el-dropdown-item>
                                <el-link type="success" :underline="false"
                                  @click="addSequence(1, carItem, item.groupNum)">前移</el-link>
                              </el-dropdown-item>
                              <el-dropdown-item>
                                <el-link type="danger" :underline="false" @click="deleteCar(carItem)">删除</el-link>
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  movePosition,
  deleteTanekrUp,
} from "@/api/smart/productTransport_outside.js";
import { getUserInfo } from "@/utils/auth.js";
import { getUserAutList } from "@/api/common.js";
export default {
  mixins: [mixin],
  data() {
    return {
      pagesType: 0,
      //websock
      websock: "",
      fourNumber: null, // 随机四位数
      time: null,
      setTime: null,
      table3: [
        { label: " 生产线", prop: "logisticsCode", status: true, width: "110", fixed: true },
        { label: "装料", prop: "productionSite", status: true, width: "auto ", fixed: true },
        { label: "排队", prop: "engineeringName", status: true, width: "400" },
      ],
      tableData3New: [],
      tableData3: [],
      stationList: [],
      UserInfo: "",
      tableParam: {
        stationId: "",
      }
    };
  },
  watch: {
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.stationList = await getUserAutList(true);
    if (this.UserInfo.pointIds.length > 0) {
      this.tableParam.stationId = this.UserInfo.pointIds[0];
    } else {
      this.tableParam.stationId = this.stationList[0].id;
    }
    this.fourNumber = this.generateRandomFourDigitNumber();
    //websock获取车辆信息
    if (this.websock) {
      this.websock.close();
    }
    this.initWebSocket();
  },
  beforeDestroy() {
    if (this.websock) {
      this.websock.close();
      console.log("close socket");
    }
  },
  destroyed() {
    this.websock.close();
  },
  methods: {
    queryTable() {
      if (this.websock) {
        this.websock.close();
      }
      this.fourNumber = this.generateRandomFourDigitNumber();
      this.initWebSocket();
    },
    //人员配置结束
    arraySpanMethod({ column, rowIndex, columnIndex }) {
      if (rowIndex === 2) {
        if (columnIndex == 0) {
          return [1, 1];
        } else {
          let obj = this.table3.find(item => item.label == column.label);
          let obj2 = this.table3.find(item => item.label == this.table3[columnIndex - 1].label);
          if (obj.groupNum == obj2.groupNum) {
            return [0, 0];
          } else {
            return [1, obj.lineNum];
          }
        }
      }
    },
    //websock  开始
    initWebSocket() {
      //初始化weosocket
      //  const wsuri = `${process.env.VUE_APP_API_WSS}websocket`; //这个必须域名连接，否则跨域,域名连接不上就服务器转两次就好了
      // const wsuri = `ws://10.31.0.109:8070/icps/websorketserver/31441432933961728/45425`;
      //const wsuri = `ws://10.31.5.70:3306/icps/websorketserver/${this.stationInfo.id}/${this.fourNumber}`;//测试地址
      const wsuri = process.env.VUE_APP_API_CL_WSS + `icps/websorketserver/${this.tableParam.stationId}/${this.fourNumber}`; //正式地址
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketonclose;
    },
    //生成随机四位数
    generateRandomFourDigitNumber() {
      let num = Math.floor(Math.random() * 10000);
      // 如果生成的数小于1000，则在前面补零
      num = num < 1000 ? "0" + num : num;
      // 如果生成的数小于100，则再次补零
      num = num < 100 ? "0" + num : num;
      // 如果生成的数小于10，则再次补零
      num = num < 10 ? "0" + num : num;
      return num;
    },
    websocketonerror() {
      //连接建立失败重连
      const self = this;
      if (self.count == 0) {
        self.count++;
        clearTimeout(self.setTime);
        self.setTime = setTimeout(function () {
          self.initWebSocket();
          self.count = 0;
        }, 3000);
      }
    },
    websocketonclose() {
      //关闭
      console.log("--------连接断开了-------");
      const self = this;
      clearTimeout(self.setTime);
      self.setTime = setTimeout(function () {
        self.initWebSocket();
      }, 3000);
    },
    websocketonmessage(e) {
      //数据接收
      const data = JSON.parse(e.data);
      this.tableData3Init(data);
    },
    websocketonopen() {
      clearInterval(this.setTime);
      clearInterval(this.time);
      this.time = setInterval(function () { }, 5000);
    },
    sendData(data) {
      if (!window.WebSocket) {
        return;
      }
      if (this.websock.readyState == WebSocket.OPEN) {
        this.websock.send(data);
      } else {
        this.initWebSocket();
      }
    },
    //车辆信息表格数据初始化
    tableData3Init(data) {
      let tableData = JSON.parse(JSON.stringify(data));
      let table = [{ label: " 生产线", prop: "lineName", status: true, width: "110", groupNum: 0 }];
      let newTableData = []; //目标数据数组
      let obj = {
        lineName: "装料",
      };
      let obj1 = {
        lineName: "准备",
      };
      let obj2 = {
        lineName: "排队",
      };
      tableData.forEach(item => {
        item.lineData.forEach(item2 => {
          let isLine = false; //判断生产线是否存入表格中  开始
          table.forEach(item3 => {
            if (item3.prop == item2.lineName) {
              isLine = true;
            }
          });
          if (!isLine) {
            table.push({ label: item2.lineName, prop: item2.lineName, status: true, width: "auto", groupNum: item.groupNum, lineNum: item.lineNum });
          } //判断生产线是否存入表格中   结束
          //数据存入对应的行中
          obj[item2.lineName] = item2.loading;
          obj1[item2.lineName] = item2.prepare;
          obj2[item2.lineName] = item.lineUp;
        });
      });
      newTableData.push(obj);
      newTableData.push(obj1);
      newTableData.push(obj2);
      this.tableData3New = newTableData;
      this.table3 = table;
    },
    //移动
    addSequence(isTask, item, group) {
      this.$confirm(`请确认是否前移${item}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        movePosition({
          carNo: item,
          stationId: this.stationInfo.id,
          isTask: isTask, //1前移2后移
          queueUpLineGroup: group, //排队生产线分组
        }).then(res => {
          if (res.code == 1001) {
            this.$message.success("移动成功!");
          }
        });
      });
    },
    //删除
    deleteCar(item) {
      this.$confirm(`请确认是否删除${item}排队？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        deleteTanekrUp({
          carNo: item,
          stationId: this.stationInfo.id,
        }).then(res => {
          if (res.code == 1001) {
            this.$message.success("删除成功!");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}

.car {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.carItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
